<template>
    <Modal v-model="mapShow"
            width = "600"
            :closable = "true"
            @on-cancel="hide"
            :mask-closable="false">
        <div slot="header">
            <div class="map-search">
                <!--<Form>-->
                    <Row>
                        <Col span="10" offset="5">
                            <Input v-model="searchKeyword" placeholder="地图搜索" @on-enter="searchMap"></Input>
                        </Col>
                        <Col span="2" offset="1">
                            <Button type="primary" @click="searchMap">搜索</Button>
                        </Col>
                    </Row>
                <!--</Form>-->
            </div>
        </div>
        <div class="map-body" v-if="init === true">
            <baidu-map ref="bdMap" class="map"
                       :ak="appKey"
                       :center="center"
                       :zoom="13"
                       :scroll-wheel-zoom="true"
                       @click="clickMap">
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT" @changeAfter="resetKeyword"></bm-city-list>
                <!--<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="false"></bm-geolocation>-->
                <bm-marker :position="{lng: y, lat: x}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
                <bm-local-search style="display: none" :keyword="keyword" :auto-viewport="true" :location="''" ></bm-local-search>
            </baidu-map>
        </div>
        <div slot="footer">
            <Button type="text" @click="clean">清除</Button>
            <Button type="primary" @click="saveMap">确定</Button>
        </div>
    </Modal>
</template>

<script>
    import Config from "@/config";
    import BaiduMap from './vue-baidu-map/components/map/Map.vue';
    import BmNavigation from './vue-baidu-map/components/controls/Navigation';
    import BmGeolocation from './vue-baidu-map/components/controls/Geolocation';
    import BmCityList from './vue-baidu-map/components/controls/CityList';
    import BmLocalSearch from './vue-baidu-map/components/search/LocalSearch';
    import BmMarker from './vue-baidu-map/components/overlays/Marker';

    export default {
        components:{
            BaiduMap,
            BmNavigation,
            BmGeolocation,
            BmCityList,
            BmLocalSearch,
            BmMarker
        },
        props:{
            //默认经纬度x-纬度y-经度,一定注意mms那边存的x-经度,y-纬度[我承认我的锅，封组件的时候写反了]
            xy : Array,
        },
        data(){
            return {
                //地图控件状态false-销毁,true-创建
                init : false,
                //百度mapAPP_KEY
                appKey : Config.hasOwnProperty('baiduMapAppKey') ? Config.baiduMapAppKey : "",
                //模态框状态
                mapShow : false,
                //默认居中定位
                center:{lng: 0, lat: 0},
                //纬度lat
                x : 0,
                //经度lng
                y : 0,
                //检索关键字
                keyword: "",
                searchKeyword: "",
            }
        },
        created(){
        },
        methods:{
            //地图搜索
            searchMap(){
                this.keyword = "";
                this.keyword = this.searchKeyword;
            },
            //切换城市后触发
            resetKeyword(){
                this.keyword = "";
                this.searchKeyword = "";
            },
            /**
             * 地图点击事件
             * @param {object} data 回调返回数据
             */
            clickMap(data){
                let point = data.point;
                //更新点的位置
                this.x = point.lat;
                this.y = point.lng;
            },
            //初始化地图数据
            initData(){
                let _self = this;
                this.keyword = "";
                this.searchKeyword = "";
                //做一些位置的初始化,默认天安门
                this.y = (this.xy && this.xy[0]) ? parseFloat(_self.xy[0]) : 116.403425;
                this.x = (this.xy && this.xy[1]) ? parseFloat(_self.xy[1]) : 39.914779;
                this.center = Object.assign({},{
                    lat : _self.x,
                    lng : _self.y
                });
            },
            //modal显示
            show(){
                let _self = this;
                this.initData();
                this.init = false;
                this.mapShow = true;
                this.$nextTick(()=>{
                    _self.init = true;
                });
            },
            //modal关闭
            hide(){
                // this.init = false;
                this.mapShow = false;
            },
            clean(){
                this.$emit('selectPoint',[]);
                this.mapShow = false;
            },
            //确认按钮事件
            saveMap(){
                this.$emit('selectPoint',[this.y,this.x]);
                this.mapShow = false;
            }
        }
    }
</script>

<style scoped>
@import "map.less";
</style>


// WEBPACK FOOTER //
// src/components/baiduMap/map.vue